// SPDX-License-Identifier: BUSL-1.1

/**
 * External tool links footer — configurable per deployment via VITE_* env vars.
 *
 * Hidden entirely if no links are configured (graceful empty state).
 *
 */

import type * as React from 'react';
import { ExternalLink } from 'lucide-react';
import { EXTERNAL_LINKS } from '@/lib/external-links';

export function ExternalLinksFooter(): React.ReactElement | null {
  if (EXTERNAL_LINKS.length === 0) {
    return null;
  }

  return (
    <footer className="flex items-center gap-1 border-t border-neutral-800 px-4 py-3">
      <span className="mr-2 text-[10px] font-semibold uppercase tracking-wider text-neutral-500">
        External
      </span>
      {EXTERNAL_LINKS.map((link, idx) => (
        <span key={link.label} className="flex items-center">
          <a
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 rounded px-2 py-1 text-xs text-neutral-500 transition hover:bg-neutral-900 hover:text-neutral-300"
          >
            {link.label}
            <ExternalLink className="size-3" />
          </a>
          {idx < EXTERNAL_LINKS.length - 1 && (
            <span className="px-1 text-xs text-neutral-700" aria-hidden="true">
              ·
            </span>
          )}
        </span>
      ))}
    </footer>
  );
}
